import { render, staticRenderFns } from "./CountdownAdmin.vue?vue&type=template&id=2204113d"
import script from "./CountdownAdmin.vue?vue&type=script&lang=js"
export * from "./CountdownAdmin.vue?vue&type=script&lang=js"
import style0 from "./CountdownAdmin.vue?vue&type=style&index=0&id=2204113d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports